<div class="c-welcomeRewardModal">
  <div class="c-welcomeRewardModal_background">
    <div
      #flyingGems
      class="e-flyingGems"
      theming
      themingGroup="none"
      [themingAsset]="'welcome-reward-flying-gems'"></div>

    <div
      #flyingCoins
      class="e-flyingCoins"
      theming
      themingGroup="none"
      [themingAsset]="'welcome-reward-flying-coins'"></div>

    <div
      #title
      class="c-welcomeRewardModal__title"
      theming
      themingGroup="none"
      [themingAsset]="'welcome-reward'"></div>

    <div class="c-welcomeRewardModal__display">
      @if (!welcomeRewardModalData.data.gems) {
        <div
          #coinsDisplay
          class="c-welcomeRewardModal__displayCredits"
          theming
          themingGroup="none"
          [themingAsset]="'welcome-bonus-coins-display-pl'">
          <span>{{ welcomeRewardModalData.data.credits | number: '1.0-0' : ('common.culture' | translate) }}</span>
        </div>
      } @else {
        <div
          #rewardsDisplay
          class="c-welcomeRewardModal__displayBoth"
          theming
          themingGroup="none"
          [themingAsset]="'welcome-bonus-gems-coins-display'">
          <div class="e-coinsDisplay">
            <span>{{ welcomeRewardModalData.data.credits | number: '1.0-0' : ('common.culture' | translate) }}</span>
          </div>

          <div class="e-gemsDisplay">
            <span>{{ welcomeRewardModalData.data.gems }}</span>
          </div>
        </div>
      }
    </div>
  </div>
</div>
